module.exports = __webpack_public_path__ + "static/media/moon-juice.8d7ff18c.png";